import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToTitle',
  standalone: true,
})
export class CamelToTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '-';
    
    return value
      .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space between lowercase and uppercase for the response from the database
      .split(' ')  // Split into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize each word
      .join(' ');  // Join back together
  }
}